/* Seletor de quantidade das LPs — snippets/lp-qs-pecas.liquid (data-lp-qs).
   Clicar em "Kit 2" / "Kit 3" carrega o kit na LP, no lugar do produto: a mesma troca que o
   tema faz com cor de produto irmão (product-info.js, ?product=<handle> na seção). "1 unidade"
   volta pro produto da LP. Depois da troca, tenta manter a cor que estava escolhida (se o kit
   tiver a mesma) com um clique no swatch — o resto (tamanho, preço, botão) é o seletor nativo.
   O tema não executa os scripts do HTML trocado: o listener é um só, delegado no document.
   Fail-safe: sem <product-info> ou sem os métodos do tema, vai pra PDP do kit.

   Modo "unidades" (data-lp-qs-modo="unidades"): as caixas só mudam o seletor de quantidade
   nativo do produto — o add continua o nativo, então o preço é o mesmo de hoje. A quantidade
   escolhida fica guardada por seção e é reposta quando o tema re-renderiza a área do produto
   (troca de cor/tamanho volta o input pra 1). O +/- nativo também atualiza as caixas. */
(function () {
  if (window.__lpQsKits) return;
  window.__lpQsKits = true;

  // Só o nome da opção ("Cor"): a legend pode trazer o valor escolhido junto.
  function nomeOpcao(fs) {
    var lg = fs.querySelector('legend');
    return lg && lg.firstChild ? lg.firstChild.textContent.trim() : '';
  }

  function corEscolhida(pi) {
    var fs = pi.querySelector('variant-selects fieldset');
    var input = fs && fs.querySelector('input[type="radio"]:checked');
    if (!input) return null;
    return { nome: nomeOpcao(fs), valor: input.value };
  }

  // Na troca o tema gera um <product-info> novo: acha o da seção de novo pelo data-section.
  function piDaSecao(secao) {
    return document.querySelector('product-info[data-section="' + secao + '"]');
  }

  function manterCor(secao, cor, handle) {
    var pi = piDaSecao(secao);
    if (!pi || !cor) return;
    var fs = pi.querySelector('variant-selects fieldset');
    if (!fs || nomeOpcao(fs) !== cor.nome) return;
    var alvo = Array.prototype.find.call(fs.querySelectorAll('input[type="radio"]'), function (i) {
      return i.value === cor.valor;
    });
    // Swatch de produto irmão (data-product-handle de outro produto) levaria pra fora do kit.
    if (!alvo || alvo.checked || alvo.disabled) return;
    if (alvo.dataset.productHandle && alvo.dataset.productHandle !== handle) return;
    alvo.click();
  }

  // Kit aberto num tamanho/gola sem peça no estoque do produto filho: o kit-explode risca a
  // opção e trava o botão ("Indisponível", data-kit-explode-disabled), mas a seleção fica lá —
  // a Shopify escolhe a variante do KIT, que nunca esgota. Passa sozinho para a primeira opção
  // disponível da mesma cor. Vigia ~4 s depois da troca (manterCor e kit-explode re-renderizam);
  // no máximo 3 ajustes, e nunca mexe na cor.
  function escolherDisponivel(secao) {
    var ajustes = 0;
    var fim = Date.now() + 4000;
    (function olhar() {
      if (Date.now() > fim || ajustes >= 3) return;
      var pi = piDaSecao(secao);
      var btn = pi && pi.querySelector('button[name="add"]');
      if (!pi || pi.getAttribute('aria-busy') === 'true' || !btn || btn.getAttribute('data-kit-explode-disabled') !== 'true') {
        setTimeout(olhar, 200);
        return;
      }
      var vss = pi.querySelectorAll('variant-selects');
      var vs = Array.prototype.find.call(vss, function (v) { return v.offsetParent !== null; }) || vss[0];
      var fss = vs ? Array.prototype.slice.call(vs.querySelectorAll('fieldset'), 1) : [];
      for (var i = 0; i < fss.length; i++) {
        var marcado = fss[i].querySelector('input[type="radio"]:checked');
        if (!marcado || !marcado.classList.contains('disabled')) continue;
        var livre = Array.prototype.find.call(fss[i].querySelectorAll('input[type="radio"]'), function (r) {
          return !r.classList.contains('disabled') && !r.disabled;
        });
        if (!livre) return; // cor inteira sem estoque: deixa o "Indisponível"
        ajustes++;
        var lbl = vs.querySelector('label[for="' + livre.id + '"]');
        (lbl || livre).click();
        break;
      }
      setTimeout(olhar, 400);
    })();
  }

  function trocar(btn, tentativa, repeticao) {
    var root = btn.closest('[data-lp-qs]');
    var pi = btn.closest('product-info');
    var handle = btn.getAttribute('data-lp-qs-handle');
    var url = '/products/' + handle;
    if (!pi) {
      window.location.href = url;
      return;
    }
    // Clique logo no carregamento: o <product-info> ainda não virou componente (JS do tema com
    // defer). Espera até 3 s; se não vier, vai pra PDP do kit.
    if (typeof pi.renderProductInfo !== 'function' || typeof HTMLUpdateUtility === 'undefined') {
      if (tentativa >= 30) {
        window.location.href = url;
        return;
      }
      setTimeout(function () { trocar(btn, (tentativa || 0) + 1, repeticao); }, 100);
      return;
    }
    var secao = pi.dataset.section;
    var cor = corEscolhida(pi);
    var topoAntes = btn.getBoundingClientRect().top;

    root.classList.add('is-loading');
    pi.setAttribute('aria-busy', 'true');
    if (typeof pi.resetProductFormState === 'function') pi.resetProductFormState();
    // A troca pode ser cancelada no meio (o tema aborta o fetch quando outra troca de
    // cor/tamanho começa): o callback não roda e o "is-loading" ficaria pra sempre, travando
    // todas as caixas. Depois de 8 s, libera.
    setTimeout(function () {
      if (root.isConnected) root.classList.remove('is-loading');
    }, 8000);

    // Busca em /products/<kit> com a LP junto (?lp_page=, ?lp_combo=), igual à troca de
    // cor/tamanho do tema (product-info.js): no caminho da LP o produto vinha do
    // content_for_header e, logo depois de trocar o tamanho, voltava o kit anterior. `_` único:
    // a resposta não pode vir de cache de outra troca.
    var extras = '';
    if (pi.dataset.lpCombo) extras += '&lp_combo=' + encodeURIComponent(pi.dataset.lpCombo);
    if (pi.dataset.lpPage) extras += '&lp_page=' + encodeURIComponent(pi.dataset.lpPage);
    pi.renderProductInfo({
      requestUrl: url + '?section_id=' + encodeURIComponent(pi.sectionId) + '&product=' + encodeURIComponent(handle) + extras + '&_=' + Date.now(),
      targetId: null,
      callback: function (html) {
        var novo = html.querySelector('product-info');
        if (!novo) {
          window.location.href = url;
          return;
        }
        // Logo depois de uma troca de cor/tamanho no kit, a Shopify às vezes devolve a seção do
        // produto ANTERIOR (o ?product= é lido no Liquid pelo content_for_header). Pintar isso
        // deixava o cliente preso no Kit 4 (v3 feedbacks Black): descarta e pede de novo; na 3ª
        // vez errada, vai pra PDP do produto clicado.
        if (handleAtual(novo) && handleAtual(novo) !== handle) {
          root.classList.remove('is-loading');
          pi.removeAttribute('aria-busy');
          if ((repeticao || 0) >= 2) {
            window.location.href = url;
            return;
          }
          setTimeout(function () { trocar(btn, 0, (repeticao || 0) + 1); }, 400);
          return;
        }
        // Igual ao handleSwapProduct do tema com data-update-url="false", mas sem rolar pro
        // topo do produto: a caixa clicada fica onde estava, embaixo do dedo.
        HTMLUpdateUtility.viewTransition(pi, novo, pi.preProcessHtmlCallbacks, pi.postProcessHtmlCallbacks);
        // O preço do combo, o card da Sizebay e as fotos mudam de altura DEPOIS da troca: por 3 s,
        // reancora a cada mudança de tamanho da página (o ResizeObserver roda antes do paint, sem
        // pulo visível).
        function ancorar() {
          var piNovo = piDaSecao(secao);
          var btnNovo = piNovo && piNovo.querySelector('[data-lp-qs-handle="' + handle + '"]');
          var dy = btnNovo ? btnNovo.getBoundingClientRect().top - topoAntes : 0;
          // 'instant': o tema tem scroll-behavior: smooth, e a animação se perderia entre as passadas.
          if (Math.abs(dy) > 2) window.scrollTo({ top: window.scrollY + dy, behavior: 'instant' });
        }
        ancorar();
        if (window.ResizeObserver) {
          var ro = new ResizeObserver(ancorar);
          ro.observe(document.body);
          // Mudança dentro do produto nem sempre muda a altura do body (uma coluna cresce, a
          // página não): observa também os blocos acima da caixa.
          var piObs = piDaSecao(secao);
          if (piObs) {
            ro.observe(piObs);
            piObs.querySelectorAll('.product__media-wrapper, .product__info-container, .product__info-container > *').forEach(function (el) {
              ro.observe(el);
            });
          }
          setTimeout(function () { ro.disconnect(); }, 3000);
        }
        manterCor(secao, cor, handle);
        escolherDisponivel(secao);
      },
    });
  }

  // Handle do produto que está na seção agora (data-url="/products/<handle>" do product-info).
  function handleAtual(pi) {
    var u = (pi && pi.dataset.url) || '';
    var i = u.indexOf('/products/');
    return i < 0 ? '' : u.slice(i + 10).split(/[?#/]/)[0];
  }

  // Caixa marcada = produto da seção (modo kits). Corrige o is-on depois de qualquer
  // re-render do tema; só escreve quando muda (roda dentro do MutationObserver abaixo).
  function sincronizarMarcada() {
    document.querySelectorAll('[data-lp-qs]:not([data-lp-qs-modo="unidades"])').forEach(function (root) {
      var h = handleAtual(root.closest('product-info'));
      if (!h) return;
      var bs = root.querySelectorAll('[data-lp-qs-handle]');
      var tem = Array.prototype.some.call(bs, function (b) { return b.getAttribute('data-lp-qs-handle') === h; });
      if (!tem) return;
      bs.forEach(function (b) {
        var on = b.getAttribute('data-lp-qs-handle') === h;
        if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on);
        if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      });
    });
  }

  // ---------- Modo unidades ----------
  var QTD = {}; // data-section → quantidade escolhida

  function inputQtd(pi) {
    return pi && pi.querySelector('quantity-input input[name="quantity"], input.quantity__input[name="quantity"]');
  }

  function marcar(root, n) {
    var achou = false;
    root.querySelectorAll('[data-lp-qs-qty]').forEach(function (b) {
      var on = Number(b.getAttribute('data-lp-qs-qty')) === n;
      if (on) achou = true;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var lbl = root.querySelector('[data-lp-qs-label]');
    if (lbl) lbl.textContent = n === 1 ? '1 unidade' : n + ' unidades';
    pintarPreco(root, n);
    pintarTitulo(root, n);
    return achou;
  }

  // Título do produto acompanha a caixa: "Kit 2x Overshirt Minimal" (mesmo padrão dos produtos
  // de kit da loja). O título original fica em data-lp-qs-titulo; 1 peça volta pra ele.
  // Três títulos na seção: h1 + h2 do celular e o h2 do computador.
  function pintarTitulo(root, n) {
    var pi = root.closest('product-info');
    if (!pi) return;
    pi.querySelectorAll('.product__title h1, .product__title h2, h2.product__title').forEach(function (h) {
      if (!h.hasAttribute('data-lp-qs-titulo')) h.setAttribute('data-lp-qs-titulo', h.textContent.trim());
      var base = h.getAttribute('data-lp-qs-titulo');
      setTxt(h, n > 1 ? 'Kit ' + n + 'x ' + base : base);
    });
  }

  // Preço da seção com 2+ peças: o total da caixa, num bloco nosso (.lp-qs-preco) com o
  // .price original escondido. Não reescreve o .price — o combo-cart-sync repinta ele por
  // MutationObserver e os dois brigariam. Só escreve o que mudou (o observer abaixo chama
  // isto a cada mutação). Quantidade fora das caixas ou 1 peça: volta o preço do tema.
  function setTxt(el, t) {
    if (el && el.textContent !== t) el.textContent = t;
  }

  function pintarPreco(root, n) {
    var pi = root.closest('product-info');
    if (!pi) return;
    var b = n > 1 ? root.querySelector('[data-lp-qs-qty="' + n + '"]') : null;
    var pix = b && b.getAttribute('data-lp-qs-pix');
    pi.querySelectorAll('.main-product-price-wrapper').forEach(function (w) {
      if (!pix) {
        if (w.classList.contains('lp-qs-total')) w.classList.remove('lp-qs-total');
        return;
      }
      var box = w.querySelector('.lp-qs-preco');
      if (!box) {
        box = document.createElement('div');
        box.className = 'lp-qs-preco';
        box.innerHTML = '<s class="lp-qs-preco__de"></s><span class="lp-qs-preco__pix"><b></b> no pix · <span></span></span><span class="lp-qs-preco__parc"></span>';
        w.appendChild(box);
      }
      var de = b.getAttribute('data-lp-qs-de') || '';
      var deEl = box.querySelector('.lp-qs-preco__de');
      setTxt(deEl, de);
      if (deEl.hidden !== !de) deEl.hidden = !de;
      setTxt(box.querySelector('.lp-qs-preco__pix b'), pix);
      setTxt(box.querySelector('.lp-qs-preco__pix span'), b.getAttribute('data-lp-qs-rotulo') || '');
      setTxt(box.querySelector('.lp-qs-preco__parc'), b.getAttribute('data-lp-qs-parcela') || '');
      if (!w.classList.contains('lp-qs-total')) w.classList.add('lp-qs-total');
    });
  }

  function aplicarQtd(pi, n) {
    var input = inputQtd(pi);
    if (!input) return false;
    if (Number(input.value) !== n) {
      input.value = n;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  // Re-render do tema (cor/tamanho): input volta pra 1 e as caixas pra "1 unidade".
  new MutationObserver(function () {
    sincronizarMarcada();
    Object.keys(QTD).forEach(function (secao) {
      var pi = piDaSecao(secao);
      var root = pi && pi.querySelector('[data-lp-qs-modo="unidades"]');
      var input = inputQtd(pi);
      if (!root || !input) return;
      if (Number(input.value) === QTD[secao]) {
        // Bloco de preço re-renderizado (troca de cor/tamanho) com a quantidade intacta.
        pintarPreco(root, QTD[secao]);
        pintarTitulo(root, QTD[secao]);
        return;
      }
      aplicarQtd(pi, QTD[secao]);
      marcar(root, QTD[secao]);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // +/- nativo: a caixa acompanha (quantidade fora da lista = nenhuma caixa marcada).
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[name="quantity"]')) return;
    var pi = input.closest('product-info');
    var root = pi && pi.querySelector('[data-lp-qs-modo="unidades"]');
    if (!root) return;
    var n = Math.max(1, parseInt(input.value, 10) || 1);
    QTD[pi.dataset.section] = n;
    marcar(root, n);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lp-qs-qty]');
    if (!b) return;
    e.preventDefault();
    var pi = b.closest('product-info');
    var n = Number(b.getAttribute('data-lp-qs-qty')) || 1;
    if (!aplicarQtd(pi, n)) return;
    QTD[pi.dataset.section] = n;
    marcar(b.closest('[data-lp-qs]'), n);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lp-qs-handle]');
    if (!btn) return;
    e.preventDefault();
    // "Já escolhido" = o produto que está NA SEÇÃO, não a classe is-on: a troca de cor/tamanho
    // do tema re-renderiza as caixas pela URL do produto (sem a LP) e o is-on podia ficar na
    // caixa errada (Kit 4 na tela com "Uma camiseta" marcada) — o clique era ignorado e o
    // cliente não saía do kit.
    var piBtn = btn.closest('product-info');
    if (piBtn && handleAtual(piBtn) === btn.getAttribute('data-lp-qs-handle')) return;
    var carregando = btn.closest('.lp-qs.is-loading');
    if (carregando && piBtn && piBtn.getAttribute('aria-busy') === 'true') return;
    if (carregando) carregando.classList.remove('is-loading');
    try {
      trocar(btn);
    } catch (err) {
      console.warn('[lp-qs] troca pro kit falhou, indo pra PDP', err);
      window.location.href = '/products/' + btn.getAttribute('data-lp-qs-handle');
    }
  });
})();
